export default __webpack_public_path__ + "static/media/logout-light.9e9cf7e3.svg";